import React from 'react';
import { ConsultationType } from '../../types';
type ConsultationTypeBadgeProps = {
  type?: ConsultationType;
  size?: 'sm' | 'md';
};
const styles: Record<ConsultationType, string> = {
  Gyne: 'bg-pink-100 text-pink-800 ring-pink-300',
  General: 'bg-blue-100 text-blue-800 ring-blue-300'
};
export function ConsultationTypeBadge({
  type,
  size = 'md'
}: ConsultationTypeBadgeProps) {
  if (!type) return null;
  return <span className={`inline-flex items-center whitespace-nowrap rounded-full font-bold uppercase tracking-wide ring-1 ring-inset ${styles[type]} ${size === 'sm' ? 'px-2 py-0.5 text-[11px]' : 'px-3 py-1 text-xs'}`} data-id="element-102" data-mp="1ln3agf5wk9b6">
      {type} Consultation
    </span>;
}